var _circle, _path, _ellipse, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgMusicBandMusicNoteContrast = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 85,
    viewBox: "0 0 85 85",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 42.5,
    cy: 42.5,
    r: 42.5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.5515 11.8886C43.5515 10.8456 44.3971 10 45.4402 10H51.1894C55.0084 11.7822 63.41 14.9646 66.4652 13.437C70.2841 11.5276 67.6109 23.7482 51.1894 26.0396V56.5911H51.1292C51.1691 57.095 51.1894 57.6045 51.1894 58.1187C51.1894 68.6644 42.6404 74.5401 32.0947 74.5401C21.549 74.5401 13 68.6644 13 58.1187C13 47.5729 21.549 39.024 32.0947 39.024C36.3933 39.024 40.3602 40.4444 43.5515 42.8415V11.8886Z",
    fill: "#1E1E1E"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 30.9384,
    cy: 52.2509,
    rx: 5.72841,
    ry: 6.4922,
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48.1792 52.3903C48.1792 55.9758 45.9565 58.0103 43.2146 58.0103C40.4727 58.0103 38.25 55.9758 38.25 52.3903C38.25 48.8047 40.4727 45.8981 43.2146 45.8981C45.9565 45.8981 48.1792 48.8047 48.1792 52.3903Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0304 59.6462H40.8287C41.4386 59.6462 41.8808 60.2178 41.6169 60.7677C41.0142 62.0237 39.8138 63.4652 37.8454 63.4652C34.5754 63.4652 32.7587 59.6462 34.0304 59.6462Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33.9061 53.7469C34.6198 54.0535 35.7066 54.187 35.8519 53.424C35.8919 53.214 35.9129 52.9958 35.9129 52.7721C35.9129 51.0848 34.7158 49.7169 33.2397 49.7169C31.7636 49.7169 30.5664 51.0848 30.5664 52.7721C30.5664 52.8291 30.5678 52.8858 30.5705 52.942C30.6046 53.6535 31.5262 53.7783 32.2186 53.6111C32.4215 53.5621 32.6359 53.5359 32.8578 53.5359C33.2356 53.5359 33.592 53.612 33.9061 53.7469Z",
    fill: "#1E1E1E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M45.6932 53.5949C46.422 53.7497 47.403 53.59 47.4161 52.845C47.4165 52.8208 47.4167 52.7964 47.4167 52.7721C47.4167 51.0848 46.3911 49.7169 45.1253 49.7169C43.8596 49.7169 42.834 51.0848 42.834 52.7721C42.834 52.7964 42.8342 52.8208 42.8346 52.845C42.8477 53.59 43.8287 53.7497 44.5575 53.5949C44.7391 53.5564 44.9293 53.5359 45.1253 53.5359C45.3214 53.5359 45.5116 53.5564 45.6932 53.5949Z",
    fill: "#1E1E1E"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMusicBandMusicNoteContrast);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/MusicBandMusicNoteContrast.2f1bf2f4e1b390cf6897d1e3bbdd981b.svg";